import { render, staticRenderFns } from "./TaskAssignedGroup.vue?vue&type=template&id=00e145b0&"
import script from "./TaskAssignedGroup.vue?vue&type=script&lang=js&"
export * from "./TaskAssignedGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports